/* ============================================================
   v2 Curso · Hot Sale 2026
   - Product switcher (tabs)
   - Countdown to 2026-06-02 23:59
   - FAQ accordion
   - Sticky mobile CTA visibility
============================================================ */
(function () {
  'use strict';
  console.log('[v2-curso] script loaded');

  // ── Product switcher (cards / tabs / radios)
  const tabs = document.querySelectorAll('[data-v2-curso-tab]');
  const panels = document.querySelectorAll('[data-v2-curso-panel]');
  const radios = document.querySelectorAll('input[name="v2-curso-pack"]');

  function activate(opt) {
    tabs.forEach(t => {
      const active = t.dataset.v2CursoTab === opt;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    panels.forEach(p => {
      const active = p.dataset.v2CursoPanel === opt;
      p.classList.toggle('is-active', active);
      p.hidden = !active;
    });
    radios.forEach(r => { if (r.value === opt) r.checked = true; });
  }

  tabs.forEach(t => t.addEventListener('click', e => {
    // Avoid double-fire when clicking the inner radio (label propagates)
    if (e.target.tagName === 'INPUT') return;
    activate(t.dataset.v2CursoTab);
  }));

  radios.forEach(r => r.addEventListener('change', () => {
    if (r.checked) activate(r.value);
  }));

  // Cross-link triggers (from panels: "ver taller" / "ver guia")
  document.querySelectorAll('[data-v2-curso-switch]').forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault();
      activate(el.dataset.v2CursoSwitch);
      const hero = document.querySelector('.v2-curso-hero');
      if (hero) hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // ── Countdown
  const cdRoot = document.querySelector('[data-v2-curso-countdown]');
  if (cdRoot) {
    const target = new Date(cdRoot.dataset.target || '2026-06-02T23:59:00');
    const els = {
      d: cdRoot.querySelector('[data-cd="days"]'),
      h: cdRoot.querySelector('[data-cd="hours"]'),
      m: cdRoot.querySelector('[data-cd="mins"]'),
      s: cdRoot.querySelector('[data-cd="secs"]')
    };
    const expiredMsg = cdRoot.dataset.expired || '';

    function tick() {
      const diff = target - new Date();
      if (diff <= 0) {
        cdRoot.innerHTML = '<p class="v2-curso-countdown__expired">' + expiredMsg + '</p>';
        clearInterval(timer);
        return;
      }
      const d = Math.floor(diff / 864e5);
      const h = Math.floor((diff % 864e5) / 36e5);
      const m = Math.floor((diff % 36e5) / 6e4);
      const s = Math.floor((diff % 6e4) / 1e3);
      if (els.d) els.d.textContent = String(d).padStart(2, '0');
      if (els.h) els.h.textContent = String(h).padStart(2, '0');
      if (els.m) els.m.textContent = String(m).padStart(2, '0');
      if (els.s) els.s.textContent = String(s).padStart(2, '0');
    }
    tick();
    const timer = setInterval(tick, 1000);
  }

  // ── FAQ accordion
  document.querySelectorAll('[data-v2-curso-faq]').forEach(item => {
    const btn = item.querySelector('[data-v2-curso-faq-toggle]');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const open = item.classList.contains('is-open');
      // close siblings
      item.closest('[data-v2-curso-faq-list]')
        ?.querySelectorAll('[data-v2-curso-faq]')
        .forEach(i => i.classList.remove('is-open'));
      if (!open) item.classList.add('is-open');
    });
  });

  // ── Sticky mobile CTA: show after hero is scrolled past
  const sticky = document.querySelector('[data-v2-curso-sticky]');
  const hero = document.querySelector('.v2-curso-hero');
  if (sticky && hero) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => sticky.classList.toggle('is-visible', !e.isIntersecting));
    }, { threshold: 0 });
    io.observe(hero);
  }

  // ============================================================
  // AJAX add-to-cart with cart drawer open + bundle support
  // ============================================================
  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      // Refresh drawer markup via sections API before opening
      fetch(`${window.routes?.cart_url || '/cart'}?section_id=cart-drawer`)
        .then(r => r.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newDrawer = doc.querySelector('cart-drawer');
          if (newDrawer) drawer.innerHTML = newDrawer.innerHTML;
          drawer.open();
        })
        .catch(() => drawer.open());
    } else {
      // Fallback: navigate to cart page
      window.location.href = '/cart';
    }
    // Update header bubble too
    const bubble = document.querySelector('#cart-icon-bubble') || document.querySelector('.v2-header__cart-bubble');
    if (bubble) bubble.dispatchEvent(new Event('cart:refresh'));
  }

  const _cursoForms = document.querySelectorAll('[data-v2-curso-form], [data-v2-curso-sticky] form');
  console.log('[v2-curso] forms found:', _cursoForms.length);

  async function handleCursoSubmit(form, e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    }
    console.log('[v2-curso] handling submit for', form);

    const btn = form.querySelector('button[type="submit"]') || form.querySelector('button');
    const originalText = btn ? btn.innerHTML : '';
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = 'Agregando…';
    }

    const idInput = form.querySelector('input[name="id"]');
    const qtyInput = form.querySelector('input[name="quantity"]');
    const primaryId = idInput?.value;
    const quantity = parseInt(qtyInput?.value || 1, 10);
    const bundleWith = form.dataset.v2BundleWith;

    const items = [{ id: parseInt(primaryId, 10), quantity }];
    if (bundleWith) {
      items.push({
        id: parseInt(bundleWith, 10),
        quantity: 1,
        properties: { '_bundle_with_taller': 'true' }
      });
    }

    console.log('[v2-curso] POST /cart/add.js with', items);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      const data = await response.json();
      console.log('[v2-curso] cart/add.js response', response.status, data);
      if (!response.ok) throw new Error(data.description || data.message || 'Cart error');
      openCartDrawer();
    } catch (err) {
      console.error('[v2-curso] add to cart failed', err);
      alert('Hubo un error al agregar al carrito: ' + (err.message || 'desconocido'));
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = originalText;
      }
    }
    return false;
  }

  _cursoForms.forEach(form => {
    // Disable native action so even if JS fails we don't redirect
    form.setAttribute('action', 'javascript:void(0)');
    form.addEventListener('submit', (e) => handleCursoSubmit(form, e));
    // Also bind directly on the button click as extra safety
    const btn = form.querySelector('button[type="submit"]') || form.querySelector('button');
    if (btn) {
      btn.addEventListener('click', (e) => {
        if (btn.disabled) return;
        handleCursoSubmit(form, e);
      });
    }
  });
})();
